import { ChangeDetectorRef, Injectable } from '@angular/core'
import { FormControl, FormGroup } from '@angular/forms'
import { AlertService } from '@app/alert/service/alert.service'
import { ModalService } from '@app/modal/modal.service'
import { FormHelperService } from '@widgets/form/services/form-helper.service'
import { ALERT_INCORRECT_FIELDS, ALERT_REQUIRED } from '@widgets/validation/messages/messages'
import { UnprocessableEntityException } from './error.model'

@Injectable({
  providedIn: 'root',
})
export class ErrorService {
  constructor(
    private alertService: AlertService,
    private formHelper: FormHelperService,
    private modalService: ModalService
  ) {}

  showUnprocessableEntityException(exception: UnprocessableEntityException) {
    const config = this.modalService.createDefaultConfig(exception)
    config.width = null
    config.minWidth = '22em'
    config.maxWidth = '60em'
    this.modalService.openInfoModal(config)
  }

  private isUnprocessableEntity(error: any) {
    return error?.error?.title && error?.error?.message
  }

  handleBackendValidationError(error, form: FormGroup, ref: ChangeDetectorRef) {
    if (!this.isUnprocessableEntity(error)) {
      this.showHintBackendValidationError(error, form, ref)
      this.alertService.showError(ALERT_INCORRECT_FIELDS)
    }
  }

  showHintBackendValidationError(error, form: FormGroup, ref: ChangeDetectorRef) {
    if (error.status === 422 && !this.isUnprocessableEntity(error)) {
      this.formHelper.notifyErrors(form, error.error)
      ref.markForCheck()
    }
  }

  showPreenchimentoObrigatorioError(form: FormGroup) {
    return this.searchPreenchimentoObrigatorio(form)
  }

  private searchPreenchimentoObrigatorio(form: FormGroup) {
    if (this.searchAnyError(form, 'Preenchimento obrigatório.')) {
      this.alertService.showError(ALERT_REQUIRED)
      return true
    }
    return false
  }

  showCamposPreenchidosFormaIncorreta(form: FormGroup) {
    if (this.searchAnyError(form)) {
      this.alertService.showError(ALERT_INCORRECT_FIELDS)
      return true
    }
    return false
  }

  // TODO: Remover caso o novo método não apresente problema
  public searchAnyErrorOld(form: FormGroup, errorValue: string = null) {
    for (const controlKey of Object.keys(form.controls)) {
      if (
        (form.controls[controlKey].invalid &&
          form.controls[controlKey] instanceof FormControl &&
          errorValue === null &&
          form.controls[controlKey].errors?.error) ||
        (errorValue !== null && form.controls[controlKey].errors?.error === errorValue)
      ) {
        return true
      } else if (form.controls[controlKey].invalid && form.controls[controlKey]) {
        return this.searchAnyErrorOld(form.controls[controlKey] as FormGroup, errorValue)
      }
    }
    return false
  }

  searchAnyError(formGroup: any, errorValue: string = null) {
    const controls = []
    this.getAllControlsWithErrors(formGroup, controls)
    for (const control of controls) {
      if (errorValue === null && control?.errors?.error && control?.invalid) {
        return true
      }
      if (errorValue !== null && control.errors?.error === errorValue && control?.invalid) {
        return true
      }
    }
    return false
  }

  private getAllControlsWithErrors(formGroup: any, allControls: any[]) {
    const controls = formGroup?.controls
    if (controls) {
      Object.keys(controls).forEach((field) => {
        const control = formGroup.get(field)
        if (control) {
          if (control?.errors?.error) {
            allControls.push(control)
          }
          this.getAllControlsWithErrors(control, allControls)
        }
      })
    }
  }
}
